import type { Card } from '@/types/entities'

/**
 * Business impact is stored in the work item's flexible attributes under one reserved key, so it needs
 * no schema change and travels with the item everywhere customAttrs already does.
 */
export const BUSINESS_IMPACT_KEY = 'businessImpact'
export const BUSINESS_IMPACT_MAX = 1000

export function businessImpactOf(card: Pick<Card, 'customAttrs'>): string {
  const v = card.customAttrs?.[BUSINESS_IMPACT_KEY]
  return typeof v === 'string' ? v.trim() : ''
}

/** The whole attribute map with the impact set, so a PATCH never drops the other attributes. */
export function withBusinessImpact(card: Pick<Card, 'customAttrs'>, text: string): Record<string, unknown> {
  const next = { ...(card.customAttrs ?? {}) }
  const clean = text.trim().slice(0, BUSINESS_IMPACT_MAX)
  if (clean) next[BUSINESS_IMPACT_KEY] = clean
  else delete next[BUSINESS_IMPACT_KEY]
  return next
}
